<template>
    <div>
        <v-card-title class="caption nav-section-title">USER MENU
        </v-card-title>
        <v-card-text>
            <v-row v-show="showMenu">
                <v-col cols="12" v-for="(item, i) in menu" :key="i">
                    <router-link :to="{name: item.routerName} " class="nav-link">
                        <span class="icon-badge">
                            <v-icon size="20">{{item.icon}}</v-icon>
                        </span>
                        <span class="ml-3 mr-3 nav-text">{{item.text}}</span>
                    </router-link>
                </v-col>
                <sign-out :view="'side'"/>
            </v-row>
        </v-card-text>
    </div>
</template>

<script>
import SignOut from './SignOut.vue'

  export default {
  components: { SignOut },
    name: 'SideMenuCard',
    data: () => ({
        showMenu: true
    }),
    props:[
        'menu'
    ],
  }
</script>

<style scoped>
.nav-section-title{
    color: rgba(255, 255, 255, 0.45);
    letter-spacing: 1.5px;
    font-weight: 700;
}
.nav-link{
    text-decoration: none;
    color: rgba(255, 255, 255, 0.75) !important;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 0.92rem;
    border-left: 3px solid transparent;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.icon-badge{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.75);
    transition: background-color 0.2s ease, color 0.2s ease;
}
.nav-link:hover{
    background-color: rgba(255, 255, 255, 0.06);
    color: #fff !important;
}
.nav-link:hover .icon-badge{
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
}
.router-link-active{
    color: #fff !important;
    background: rgba(251, 140, 0, 0.14);
    border-left: 3px solid #FB8C00;
    padding-left: 9px;
    font-weight: 700;
}
.router-link-active .icon-badge{
    background: rgba(251, 140, 0, 0.22) !important;
    color: #FB8C00 !important;
}
.router-link-active .nav-text{
    color: #fff !important;
}
</style>
